import { AdCampaignResultWithContentDetail } from 'api';
import { ActionItemRow } from 'components/ActionItemsList';
import { useCallback } from 'react';
import { displayDate } from 'utils/date';
import { getCampaignEpisode } from '../CampaignCreationContext/utils';
import { getEpisodeTitle } from '../CampaignCreationView/EpisodeStep/PodcastEpisodeInput';
import { PRICES_BY_PLACEMENT } from '../CampaignCreationView/ObjectiveStep/constants';
import { CAMPAIGN_PLACEMENT_LABEL } from '../constants';
import PreviousCampaignThumbnail from './PreviousCampaignThumbnail';
import * as S from './styles';

export interface PreviousCampaignsListItemProps {
  campaign: AdCampaignResultWithContentDetail;
  onRunAgain: (campaign: AdCampaignResultWithContentDetail) => void;
}

const PreviousCampaignsListItem: React.FC<PreviousCampaignsListItemProps> = ({
  campaign,
  onRunAgain,
}) => {
  const { createdAt, sponsorPlacement, campaignBudgetMilliCent } = campaign;

  const placement = sponsorPlacement || 'headlinerApp';
  const title = getEpisodeTitle(getCampaignEpisode(campaign));

  const createHandleRunAgain = useCallback(
    (campaignToRunAgain: AdCampaignResultWithContentDetail) => () => {
      onRunAgain(campaignToRunAgain);
    },
    [onRunAgain],
  );

  return (
    <ActionItemRow key={createdAt}>
      <PreviousCampaignThumbnail campaign={campaign} />

      <ActionItemRow.HeadingContainer>
        <ActionItemRow.Title>{title}</ActionItemRow.Title>

        <ActionItemRow.Description>
          {displayDate(createdAt, 'MMM DD, YYYY')}
          {' • '}
          {CAMPAIGN_PLACEMENT_LABEL[placement]}
          {' • '}
          {
            PRICES_BY_PLACEMENT[placement].find(
              ({ value }) => value === campaignBudgetMilliCent,
            )?.description
          }{' '}
          (${Number(campaignBudgetMilliCent) / 100000})
        </ActionItemRow.Description>
      </ActionItemRow.HeadingContainer>

      <S.RunAgainButton onPress={createHandleRunAgain(campaign)}>
        run again
      </S.RunAgainButton>
    </ActionItemRow>
  );
};

export default PreviousCampaignsListItem;
